<script setup lang="ts">
import { IonLoading, IonPage, IonRouterOutlet, IonTabs } from '@ionic/vue';
import { storeToRefs } from 'pinia';

import NativeAppModal from '@/components/NativeAppModal.vue';
import TabBarAuthenticated from '@/components/base-wrapper/TabBarAuthenticated.vue';
import TabBarPublic from '@/components/base-wrapper/TabBarPublic.vue';
import StoriesOverlay from '@/components/stories/StoriesOverlay.vue';
import { useAuthStore } from '@/stores/auth';
import { useLoadingStore } from '@/stores/loading';

const authStore = useAuthStore();
const loadingStore = useLoadingStore();
const { showLoading, message } = storeToRefs(loadingStore);
</script>

<template>
  <ion-page>
    <stories-overlay />
    <native-app-modal />
    <ion-loading
      :is-open="showLoading"
      :message="message"
    />
    <ion-tabs>
      <ion-router-outlet />
      <tab-bar-authenticated v-if="authStore.user" />
      <tab-bar-public v-else />
    </ion-tabs>
  </ion-page>
</template>

<style lang="less">
ion-tab-bar {
  height: 60px;
  --background: var(--primary-900);
  border-top: 1px solid var(--primary-500);
}

ion-tab-button {
  ion-icon,
  ion-label {
    color: #fff;
    font-weight: 500;
  }
  &.tab-selected {
    --background: var(--secondary-900);
  }
  &.tab-selected {
    position: relative;
  }
}

ion-loading {
  --background: #fff;
  --spinner-color: var(--primary-900);

  .loading-wrapper {
    font-size: var(--font-size-h3);
    font-weight: normal;
    color: var(--primary-900);
    border-radius: var(--base-border-radius) !important;
    padding: calc(var(--base-gap) * 1.5) !important;
  }
  ion-spinner {
    color: var(--primary-900) !important;
  }
}
</style>
